import _ from 'lodash';
import { colorToString } from 'components/Editor/helper/color';

export const getColorsConfig = (colorConfig) => {

  if(!colorConfig) {
    return "inherit";
  }

  if (colorConfig.type == 'solid') {
    var colorRgb = colorConfig.color || colorConfig
    return `rgba(${colorRgb.r}, ${colorRgb.g}, ${colorRgb.b}, ${colorRgb.a})`
  }

  if (colorConfig.type == 'gradient') {
    var gradientType = _.get(colorConfig, 'gradientType', 'Linear')
    const degree = _.get(colorConfig, 'degree')
    const colorStrings = _.map(_.get(colorConfig, 'gradientColors'), color => {
      const rgb = `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`;
      const position = `${color.position}%`;
      return `${rgb} ${position}`;
    });
    let gradientColor = colorStrings.join(', ');

    
    switch (gradientType) {
      case 'Linear':
        gradientColor = `linear-gradient(${degree}deg, ${gradientColor} )`
        break;

      case 'Radial':
        gradientColor = `radial-gradient(circle at 50% 50%, ${gradientColor} )`
        break;

      case 'Angular':
        gradientColor = `conic-gradient(from ${degree}deg at 50% 50%, ${gradientColor} )`
        break;

      default:
        gradientColor = `linear-gradient(${degree}deg, ${gradientColor} )`
        break;
    }

    return gradientColor;
  }

  if(colorConfig &&  _.has(colorConfig, 'rbg') && _.isNull(colorConfig.rbg)) {
    return `rgba(0,0,0,0)`
  }

  var colorRgb = colorConfig.color || colorConfig;
  return colorRgb ? `rgba(${colorRgb.r}, ${colorRgb.g}, ${colorRgb.b}, ${colorRgb.a})` : `rgba(255, 255, 255, 1)`
}

//BoxShadow
export function getBoxShadow(value) {
    if (!value) {
      return null;
    }
    var styles = {};
    
    var shadowColor = colorToString( _.get(value, 'color', {r: 255, g: 255, b: 255, a: 1}));
    var xValue = _.get(value, 'axes.x', 0);
    var yValue = _.get(value, 'axes.y', 0);
    var bValue = _.get(value, 'axes.b', 0);
    var showShadow = _.get(value, 'show', false);
  
    if(!showShadow) {
     return null;
    }
    var boxShadow = `${xValue}px ${yValue}px ${bValue}px ${shadowColor}`
    styles['boxShadow'] = boxShadow
  
    return styles;
  }

//DropShadow
export function getDropShadow(value) {

  if (!value) {
    return null;
  }

  var shadowColor = colorToString( _.get(value, 'color', {r: 255, g: 255, b: 255, a: 1}));
  var xValue = _.get(value, 'axes.x', 0);
  var yValue = _.get(value, 'axes.y', 0);
  var bValue = _.get(value, 'axes.b', 0);
  var showShadow = _.get(value, 'show', false);

  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  if(!showShadow) {
    return null;
  }

  var shadow = {
    "filter": `drop-shadow(${xValue}px ${yValue}px ${bValue}px ${shadowColor})`,
    "WebkitFilter": `drop-shadow(${xValue}px ${yValue}px ${bValue}px ${shadowColor})`
  };

  if(isSafari) {
    shadow = {
      ...shadow,
      "willChange": "filter"
    }
  }

  return shadow;
}